import { Action } from '@ngrx/store';

export const GO_TO_PAGE_BG20 = '[Navigation Component] GoToPageBG20';
export const UPDATE_BG20_PENDING_TRANSACTION = '[Navigation Component] UpdateBg20PendingTransaction';
export const UPDATE_BG20_ACCOUNT_TABLE = '[Navigation Component] UpdateBg20AccountTable';
export const UPDATE_BG20_TRANSACTION_HISTORY = '[Navigation Component] UpdateBg20TransactionHistory';
export const CHANGE_BG20_POLICY = '[Navigation Component] ChangeBg20Policy';
export const SET_BG20_SELECTED_ACCOUNT = '[Navigation Component] SetBg20SelectedAccount';
export const RESET_BG20_STATE = '[Navigation Component] ResetBg20State';
export const UPDATE_BG20_CONTRIBUTION_SUMMARY = '[Navigation Component] UpdateBg20ContributionSummary';

export class GoToPageBG20 implements Action { readonly type = GO_TO_PAGE_BG20; constructor(public payload: any) { } }

export class UpdateBg20ContributionSummary implements Action { readonly type = UPDATE_BG20_CONTRIBUTION_SUMMARY; constructor(public payload: any) { } }

export class UpdateBg20PendingTransaction implements Action { readonly type = UPDATE_BG20_PENDING_TRANSACTION; constructor(public payload: any) { } }

export class UpdateBg20AccountTable implements Action { readonly type = UPDATE_BG20_ACCOUNT_TABLE; constructor(public payload: any) { } }

export class UpdateBg20TransactionHistory implements Action { readonly type = UPDATE_BG20_TRANSACTION_HISTORY; constructor(public payload: any) { } }

export class SetBg20SelectedAccount implements Action { readonly type = SET_BG20_SELECTED_ACCOUNT; constructor(public payload: any) { } }

export class ChangeBg20Policy implements Action { readonly type = CHANGE_BG20_POLICY; constructor(public payload: any) { } }

export class ResetBg20State implements Action { readonly type = RESET_BG20_STATE; constructor() { } }

export type Actions
  =
  GoToPageBG20 |
  UpdateBg20ContributionSummary |
  UpdateBg20PendingTransaction |
  UpdateBg20AccountTable |
  UpdateBg20TransactionHistory |
  SetBg20SelectedAccount |
  ChangeBg20Policy |
  ResetBg20State;
